module.exports = __webpack_public_path__ + "img/traveller_idle.01e55e5b.svg";